<mat-toolbar color="primary">
  <mat-toolbar-row>
    @if (proposalData.newProposal) {
      <span>{{ 'modals.modal-new-proposal.add-proposal' | translate}}</span>
    }
    @if (!proposalData.newProposal) {
      <span>{{ proposalData.proposal.title }}</span>
    }
    <span class="modal-toolbar-spacer"></span>
    <button mat-icon-button class="ml-auto close-toolbar-btn" (click)="closeDialogue()"
      [matTooltip]="'generic.buttons.close' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar-row>
</mat-toolbar>

@if (newProposal) {
  <app-new-proposal-blank [framework]="proposalData.decision_table.framework" [decision_table]="proposalData.decision_table"  (proposalSavedEvent)="closeDialogue($event)"></app-new-proposal-blank>
}
@if (!newProposal) {
  <app-new-proposal [current_organization]="data.current_organization" [proposal]="proposalData.proposal" [framework]="proposalData.decision_table.framework" [decision_table]="proposalData.decision_table" (proposalSavedEvent)="closeDialogue($event)"></app-new-proposal>
}

